import get from 'lodash.get';
import keyBy from 'lodash.keyby';
import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { DocumentsState, Document } from './types';

const selectDocumentId = (
    state: AppState,
    { documentId }: { documentId: number }
) => documentId;

const selectDocuments = (state: AppState): DocumentsState => state.documents;

const selectDocumentsKeyedById = createDeepEqualSelector(
    selectDocuments,
    (documents) => keyBy(documents, 'id')
);

const selectDocument = createDeepEqualSelector(
    selectDocumentsKeyedById,
    selectDocumentId,
    (documents, documentId) => {
        return get(documents, documentId);
    }
);

const selectDocumentsArray = createDeepEqualSelector(
    selectDocuments,
    (documents) => Object.values(documents)
);

const makeSelectDocumentValue = <T extends keyof Document>(field: T) =>
    createDeepEqualSelector(selectDocument, (document): Document[T] => {
        return get(document, field);
    });

export {
    selectDocuments,
    selectDocumentsKeyedById,
    selectDocumentsArray,
    makeSelectDocumentValue
};
